// extracted by mini-css-extract-plugin
export default {"cvError":"F5-z"};